var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackground = function SvgBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1152,
    height: 794,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "background_svg__a",
    width: 1377,
    height: 912,
    x: 0,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0-8h1377v912H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background_svg__a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#background_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__c)",
    stroke: "#78FF56",
    strokeWidth: 30,
    d: "M862.662 347.635C837.9 468.417 734.806 561.931 636.375 561.931s-163.181-93.514-138.418-214.296 127.857-214.296 226.288-214.296 163.18 93.514 138.417 214.296Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#background_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE974",
    d: "M240.104 299.305c.803-64.2-55.032-109.578-47.999-172.942 12.34-111.188 261.51 131.851 251.743 243.433-4.095 46.756-18.729 75.435-63.322 105.736-80.935 54.992-234.989 77.268-304.022 0-70.938-79.397 162.498-88.183 163.6-176.227"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__b",
    width: 1005.81,
    height: 1057.98,
    x: 177.404,
    y: -181.355,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2079_153",
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background_svg__d",
    width: 981.039,
    height: 1027.56,
    x: -236.912,
    y: -202.081,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2079_153",
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__c",
    x1: 551.032,
    x2: 998.407,
    y1: 15.599,
    y2: 179.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A4145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3E986C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A7B542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1A602"
  })))));
};
export default SvgBackground;